/**
 * @generated SignedSource<<8cebba348746f5f4ebe6bc1dc6e89a0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
    readonly showMakeOffer: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_displayInfo";
};
export type PdpRespMarketplaceStickyHeader_displayInfo$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showMakeOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "753af9c9779635a406da5b45f0e1916b";

export default node;
